import SVGIcon from "src/components/SVGIcon";

const MyAppsIcon = ({ title = "My Apps", ...props }) => {
  return (
    <SVGIcon viewBox="0 0 24 24" title={title} fill="none" {...props}>
      <path
        d="M2 17L12 22L22 17M2 12L12 17L22 12M12 2L2 7L12 12L22 7L12 2Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SVGIcon>
  );
};

export default MyAppsIcon;
